<template>
  <page :title="pageTitle">
    <transition name="page" mode="out-in">
      <div>
        <h6 class="page-title-small mt-5 offset-sm-2">{{ $t('topup_balance') }}: €{{ balance }}</h6>
        <form @submit.prevent="sendAmount" v-if="!sent" :key="sent">
          <div class="row">
            <div class="col-sm-8 offset-sm-2">
              <div class="form-group" :class="{'has-danger': errors.has('amount')}">
                <label for="amount">{{ $t('topup_amount') }}</label>
                <select v-model="selected"
                        v-validate="'required'"
                        name="amount"
                        id="amount"
                        class="form-control">
                  <option v-for="(option,index) in options"
                          :value="option"
                          :disabled="index===0"
                          :key="index">
                    {{ option.text }}
                  </option>
                </select>
              <div v-if="selected.other">
                <div class="form-group" :class="{'has-danger': errors.has('customamount')}">
                  <label for="customamount">{{ $t('topup_customAmount') }}</label>
                  <input v-model="selected.amount"
                         v-validate="'required|min_value:1'"
                         name="customamount"
                         :class="{'form-control-danger': errors.has('customamount')}"
                         id="customamount"
                         type="number"
                         class="form-control">
                  <small class="form-text text-danger" v-if="errors.has('customamount')">
                    {{ errors.first('customamount') }}
                  </small>
                </div>
              </div>
              </div>

              <div
                   :class="{ 'input-space': !selected.other }">
                <div class="form-group-btn">
                  <button type="submit" :disabled="errors.any()" class="btn btn-primary pull-right">
                    <i class="fas fa-hand-holding-usd" aria-hidden="true"></i>
                    {{ $t('topup_submit') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="row text-center" v-if="sent" :key="sent">
        <div class="col-md-8 offset-md-2">
          <p>{{ $t('topup_submitted') }}</p>
        </div>
      </div>
    </transition>
  </page>
</template>

<script>
import Page from './utilities/Page'

export default {
  name: 'Topup',
  components: {Page},
  data () {
    return {
      sent: false,
      balance: 14.55,
      options: [
        { text: 'Please select one', amount: -1 },
        { text: '€4+1', amount: 5 },
        { text: '€10', amount: 10 },
        { text: '€15', amount: 15 },
        { text: 'Other', amount: 0, other: true }
      ],
      selected: {},
    }
  },
  computed: {
    pageTitle () {
      return this.$t('side_topUp')
    },
  },
  methods: {
    sendAmount () {
      console.log('Amount submitted: ', this.selected.amount)
    },
  },
  created () {
    this.selected = this.options[0]
  },
}
</script>

<style scoped>
  .input-space {
    padding-top: 78px;
  }
  .page-enter-active, .page-leave-active {
    transition: opacity .3s;
  }

  .page-enter, .page-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Topup.vue